/**
 * Helper to safely parse JSON from a fetch Response, even if the body stream
 * has been read by a third-party interceptor (e.g. analytics/widget scripts).
 *
 * Usage:
 *   const response = await fetch(url, opts);
 *   const data = await readJson(response);
 *   if (!response.ok) throw new Error(data.detail || 'Error');
 */
export async function readJson(response) {
  try {
    return await response.clone().json();
  } catch {
    try {
      const text = await response.clone().text();
      return text ? { detail: text } : {};
    } catch {
      return {};
    }
  }
}
